// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3mkez","footer":"ModalError_footer__156WQ"};